<nav class="hide-for-print shortcut-menu hidden-sm-down" #backToTop aria-labelledby="back-to-top">
  <a href="javascript:void(0);" class="menu-item btn" placement="left" (click)="scrollTop($event)" tooltip="Scroll Top" [delay]="500"
    aria-label="Back to top link">
    <span id="back-to-top" class="visually-hidden">Back to top</span>
  </a>
</nav>
